import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faGripLines } from '@fortawesome/pro-light-svg-icons';

export type ProLightGripLinesProps = IconComponentProps;

export const ProLightGripLines = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightGripLinesProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faGripLines}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faGripLines}
    />
  );
};

ProLightGripLines.displayName = 'ProLightGripLines';
